import classnames from 'classnames';
import React, { FC } from 'react';
import { Color } from '../../../../constants/Color';
import styles from './ColorFilterNode.scss';
import { IOuter } from './ColorFilterNode.types';

export const ColorFilterNode: FC<IOuter> = ({
  color = Color.Transparent,
  innerCircleStyle = {},
  isSelected,
  onClick,
  children,
}) => (
  <button className={classnames(styles.component, { [styles.selected]: isSelected })} onClick={onClick}>
    <span className={styles.inner} style={{ backgroundColor: `#${color}`, ...innerCircleStyle }}>
      {children}
    </span>
  </button>
);
